import AppHeader from '../AppHeader'
export default {
  name: 'shift-list',
  created () {
    this.search()
  },
  beforeRouteUpdate (to, from, next) {
    next()
    this.search()
  },
  data () {
    return {
      searchCallbackFlag: false,
      confirmFlag: false,
      thisDate: new Date(),
      localShifts: null
    }
  },
  computed: {
    shift_dates () {
      return this.$store.getters.shift_dates
    },
    shifts () {
      return this.$store.getters.shifts
    },
    loading () {
      return this.$store.getters.apiLoading
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function() {
      var self = this

      var days_row_count = 6
      var days_column_count = 7
      this.localShifts = new Array(days_row_count)
      for (var i = 0; i < days_row_count; i++) {
        this.localShifts[i] = new Array(days_column_count)
      }

      var ym = this.validityCheckParamYM()
      var year = ym[0]
      var month = ym[1]
      this.thisDate = new Date(year, month - 1, 1)
      this.searchCallbackFlag = false
      this.judgmentConfirmFlag()

      var data = {
        'user_id': window.localStorage.getItem('user_id'),
        'shop_id': window.localStorage.getItem('shop_id'),
        'target_date': this.formatDate(year, month)
      }
      var callback
      callback = function() {
        self.searchCallbackFlag = true
        var length = Object.keys(self.shift_dates).length
        if (length > 0) {
          var first_key = Object.keys(self.shift_dates)[0]
          var week = self.shift_dates[first_key]['week']
          var start_index = self.getStartIndex(week)
          var column_index = start_index
          var row_index = 0
          for (var i = 0; i < length; i++) {
            var key = Object.keys(self.shift_dates)[i]
            var obj = self.shift_dates[key]
            var shift = null
            var exist_shift = false
            if (self.shifts[key]) {
              shift = self.shifts[key]
              exist_shift = true
            }
            var shift_date_day_format = new Date(key).getDate()
            if (column_index > 6) {
              column_index = 0
              row_index++
            }
            var view_name = (shift)? shift['view_name']:null
            var class_name = (shift)? shift['class_name']:null
            var is_default = (shift)? shift['is_default']:null
            var is_edited = (shift)? shift['is_edited']:null
            var data = {
                shift_date: key,
                is_holiday: obj['is_holiday'],
                week: obj['week'],
                shift_date_day_format: shift_date_day_format,
                view_name: view_name,
                class_name: class_name,
                is_default: is_default,
                is_edited: is_edited,
                exist_shift: exist_shift
            }
            self.localShifts[row_index][column_index] = data
            column_index++
          }
          self.$forceUpdate()
        }
      }
      this.$store.dispatch('SHIFT_LIST_SEARCH',  {data: data, callback: callback})
    },
    validityCheckParamYM: function() {
      var year = null
      var month = null
      var ym = this.$route.params.ym
      if (ym) {
        var ymi = parseInt(ym.replace('-', ''), 10)
        var y = parseInt(ymi / 100, 10)
        var m = parseInt(ymi % 100, 10)
        if (y >= 2018) year = y
        if (m >= 1 && m <= 12) month = m
      }
      if (!year) {
        year = new Date().getFullYear()
      }
      if (!month) {
        month = (new Date().getMonth()) + 1
      }
      return [year, month]
    },
    formatDate: function(year, month) {
      if (!year) year = (new Date()).getFullYear()
      if (!month) month = (new Date()).getMonth() + 1
      return year + '-' + ('00' + month).slice(-2) + '-01'
    },
    getStartIndex: function(week) {
      var start
      if (week === '月') start = 0
      if (week === '火') start = 1
      if (week === '水') start = 2
      if (week === '木') start = 3
      if (week === '金') start = 4
      if (week === '土') start = 5
      if (week === '日') start = 6
      return start
    },
    thisYear: function() {
      return this.thisDate.getFullYear()
    },
    thisMonth: function() {
      return this.thisDate.getMonth() + 1
    },
    judgmentConfirmFlag: function() {
      var base = new Date()
      var base_date = base.getDate()
      // 本日が26日以後の場合、翌月末に置換
      if (base_date > 25) {
        base = new Date(base.getFullYear(), base.getMonth() + 2, 0)
      }
      if (this.thisDate < base) {
        this.confirmFlag = true
      } else {
        this.confirmFlag = false
      }
    },
    existShift: function(shifts) {
      var arr = shifts.filter(v => v)
      if (arr.length > 0) return true
      return false
    },
    getShiftClassClass: function(is_default, is_edited) {
      if (is_edited === 1) return '-changed'
      if (is_default === 1) return '-default'
      return ''
    },
    getPrevMonth: function() {
      // 先月末日
      var dt = new Date(this.thisDate.getFullYear(), this.thisDate.getMonth(), 0)
      return dt.getMonth() + 1
    },
    getNextMonth: function() {
      // 翌月末日
      var dt = new Date(this.thisDate.getFullYear(), this.thisDate.getMonth() + 2, 0)
      return dt.getMonth() + 1
    },
    goPrevMonth: function() {
      // 先月末日
      var dt = new Date(this.thisDate.getFullYear(), this.thisDate.getMonth(), 0)
      var ym = dt.getFullYear() + '-' + ("00" + (dt.getMonth()+1)).slice(-2)
      this.$router.push({ path: '/shift_list/' + ym })
    },
    goNextMonth: function() {
      // 翌月末日
      var dt = new Date(this.thisDate.getFullYear(), this.thisDate.getMonth() + 2, 0)
      var ym = dt.getFullYear() + '-' + ("00" + (dt.getMonth()+1)).slice(-2)
      this.$router.push({ path: '/shift_list/' + ym })
    },
    goShiftDetail: function(shift) {
      if (!shift || shift['exist_shift'] === false) return false
      var shift_date = shift['shift_date']
      this.$router.push({ path: '/shift_detail/' + shift_date })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shift-list.js